<script setup lang="ts">
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

defineOptions({
  name: 'OrderPaymentActions',
})

const props = defineProps<{
  paymentId: number
}>()

const emit = defineEmits<{
  'click:changelog': []
}>()

const isOpen = ref<boolean>(false)
const containerRef = ref<HTMLElement | null>(null)
const floatingRef = ref<HTMLElement | null>(null)

const { floatingStyles } = useFloating(containerRef, floatingRef, {
  placement: 'bottom-end',
  strategy: 'fixed',
  whileElementsMounted: autoUpdate,
  middleware: [
    offset(4),
    flip(),
    shift({ padding: 8 }),
  ],
})

const toggle = (): void => {
  isOpen.value = !isOpen.value
}

const handleChangelog = (): void => {
  isOpen.value = false
  emit('click:changelog')
}

onClickOutside(containerRef, () => {
  isOpen.value = false
})
</script>

<template>
  <div
    ref="containerRef"
    class="order-payment-actions"
  >
    <BtnIcon
      :icon="faEllipsisVertical"
      view="table"
      :title="`Actions for payment #${props.paymentId}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="order-payment-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Changelog"
          color="blue"
          @click="handleChangelog"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./OrderPaymentActions.scss" />
